import { render, staticRenderFns } from "./Lookandfeel.vue?vue&type=template&id=aba4402a&"
import script from "./Lookandfeel.vue?vue&type=script&lang=js&"
export * from "./Lookandfeel.vue?vue&type=script&lang=js&"
import style0 from "./Lookandfeel.vue?vue&type=style&index=0&id=aba4402a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports